const apiEndpoints = {
  auth: 'auth',
  courseChild: 'course/child',
  getCourse: 'course/getCourse',
  getCourses: 'course/getCourses',
  logout: 'auth/logout',
  saveMaterial: 'material/save/',
  clearMaterial: 'redis/clearMeterial',
  getCompletedSessionsSubject: 'session/getCompletedSessionsSubject',
  getSessions: 'session/getSessions',
  averageBatchTests: 'testPaperAssign/averageBatchTests',
  scheduleTestsForStudent: 'testPaperAssign/scheduleTestsForStudent',
  attemptedTestsForStudent: 'testPaperAssign/attemptedTests',
  testStatus: 'studentAnswer/testStatus',
  testPaperForStudent: 'testPaperVo/testPaperForStudent',
  getStudentTestPaper: 'testPaperVo/getStudentTestPaper',
  saveAnswer: 'studentAnswer/next',
  submitTestPaper: 'studentTestPaperAnswer/submitTestPaper',
  saveRegistration: 'userDetail/saveReg',
  completedRegistration: 'userDetail/completedReg',
  getAllPrivateCourses: 'course/getAllPrivateCourses',
  answeredTestPaper: 'studentTestPaperAnswer/answeredTestPaper',
  resetPassword: 'auth/changePassword',
  reportQuestion: 'questionPaper/report',
  getInstitutes: 'coachingCentre',
  getBranches: 'coachingCentreBranch/branchByCoachingCentreId',
  getBatches: 'batch/getBatches',
  getAdminList: 'userDetail/search',
  getBranchList: 'coachingCentreBranch/search',
  getAvailableCourses: 'course/additionalCourseList',
  getWebexUsers: 'webexUser/notMappedWebexUsers',
  saveBranch: 'coachingCentreBranch/save',
  coachingCentreBranch: 'coachingCentreBranch/',
  getBranchById: 'coachingCentreBranch/coachingCentreBranchById',
  getAllCoursesByInstitute: 'course/allCoursesByCoaching',
  getBranchesForCourse: 'coachingCentreBranch/branchesForCourse',
  getBatchesForCourse: 'batch/batchesByCourse',
  getChildCourse: 'course/child/',
  getMaterialsWithPublishStatus: 'materialAccess/materialsWithPublishStatus',
  unPublishMaterial: 'materialAccess/unPublishMaterial',
  saveMaterialAccess: 'materialAccess/save',
  saveUserDetail: 'userDetail/save',
  deleteUserDetail: 'userDetail/delete/',
  editUserDetail: 'userDetail/',
  getMaterialByTopic: 'material/courseId/',
  deleteInstitute: 'coachingCentre/delete/',
  getAdditionalCourses: 'coachingAdditionalCourse/getAdditionalCourses',
  getInstituteById: 'coachingCentre/coachingCentreById/',
  editInstitute: 'coachingCentre/',
  addInstitute: 'coachingCentre/save/',
  getAllBatches: 'batch/search',
  getBranchByInstitute: 'coachingCentreBranch/branchByCoachingCentreId',
  saveBatch: 'batch/save',
  deleteBatch: 'batch/',
  getSession: 'session/getSession',
  deleteSession: 'session/deleteSession',
  getZoomUsers: 'zoomUser/zoomUsers',
  getWebexUserByBranch: 'webexUser/webexUserListByBranches',
  saveSession: 'session/save',
  editSession: 'session/updateSession',
  getAllCourses: 'course',
  deleteCourse: 'course/delete/',
  getCoachingCenter: 'coachingCentre',
  saveCourse: 'course/save/',
  bulkEntry: 'uploadFile/save',
  uploadFile: 'uploadFile',
  createPaymentOrder: 'userDetail/initiatePayment',
  updatePaymentOrderFailed: 'userDetail/updatePaymentStatus',
  addAssignment: 'assignment/addAssignment',
  downloadStudentActivity: 'userActivityLog/downloadUserActivity/',
  editCourse: 'course/',
  getLesson: 'lessonPlan/getByUserId',
  lessonUpdate: 'lessonPlan/updateStatus',
  getLearnSession: 'sessionPlan/getAll',
  sessionPost: 'sessionPlan/init',
  assignSession: 'sessionPlan/update',
  clearCourse: 'redis/clearCourse',
  clearMaterialCache: 'redis/clearMeterial',
  studentRegistration: 'userDetail/save',
  applyLeave: 'leave/applyLeave',
  getLeaveDetails: 'leave/getLeaveDetails',
  getLeaveMasterDetails: 'leave/getLeaveMasterDetails',
  getLeaveStatus: 'leave/getLeaveStatus',
  approveLeave: 'leave/approved/',
  rejectLeave: 'leave/rejected/',
  createLeaveMaster: 'leave/createLeaveMaster',
  qrList: 'qrcode',
  getQuestionPaperTopics: 'questionPaper/questionPaperTopics',
  getQuestionPapers: 'questionPaper/search',
  createTest: 'questionPaper/bulkConversion',
  fetchBulkQuestions: 'questionPaper/searchBulk',
  assignQrCode: 'qrcode/manageQrCode',
  getDashboardCount: 'dashboard/detail/',
  getqrDetailsbyScan: 'qrcode/getById/',
  clearLoginend: 'redis/clearLogin',
  dailyTest: 'test_mock/test'
}

export default apiEndpoints
